module.exports = __webpack_public_path__ + "static/qh_17.97266ebb.jpg";